<template>
  <div class="cdethttj">
    <div class="top between">
      <sub-title :text="httle" />
      <div class="htmore" @click="clrigicon" v-if="ismore">更多></div>
      <div class="hthyp" @click="clrigicon" v-if="!ismore">
        <img src="../../../assets/contmodeldet/hyp.png" />换一批
      </div>
    </div>
    <div class="felist between wrap">
      <div class="feitem" v-for="item in 4" :key="item">
        <div class="filecov">
          <img src="../../../assets/jpcol/htcover_sample.png" />
          <div class="xz center">
            <div class="dldbtn">下载文档</div>
          </div>
        </div>
        <div class="filetitl">个人房屋装修合同房本</div>
        <div class="downnum">0次下载</div>
      </div>
    </div>
  </div>
</template>

<script>
import subTitle from "views/home/components/subTitle";
export default {
  props: {
    ismore: {
      type: Boolean,
      default: false,
    },
    httle: {
      type: String,
      default: "相关合同",
    },
  },
  components: {
    subTitle,
  },
  methods: {
    clrigicon() {
      this.$emit("rigclick");
    },
  },
};
</script>

<style lang="scss" scoped>
.cdethttj {
  width: 100%;
  padding: 23px 12px 0;
  .top {
    .htmore {
      font-size: 14px;
      color: #999999;
      line-height: 14px;
      cursor: pointer;
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }
    .hthyp {
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      cursor: pointer;
      font-size: 14px;
      color: #0465ea;
      img {
        width: 16px;
        margin-right: 8px;
      }
    }
  }
  .felist {
    width: 100%;
    padding: 20px 8px;
    .feitem {
      width: 127px;
      margin-top: 12px;
      .filecov {
        position: relative;
        img {
          width: 127px;
          height: 170px;
        }
        .xz {
          display: none;
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 80px;
          background-color: rgba($color: #fff, $alpha: 0.8);
          .dldbtn {
            cursor: pointer;
            width: 80px;
            height: 26px;
            background: #f25618;
            border-radius: 13px;
            color: #fff;
            font-size: 14px;
            line-height: 26px;
            text-align: center;
          }
        }
      }
      .filetitl {
        font-size: 16px;
        color: #333333;
        line-height: 204x;
      }
      .downnum {
        font-size: 12px;
        color: #999999;
        line-height: 20px;
      }
      &:hover {
        .xz {
          display: flex;
        }
      }
    }
  }
}
</style>